<div class="table-w-dropdown-container" [style.marginTop]="data?.marginTop">
  <h3 class="table-title" *ngIf="data?.title">{{ data?.title }}</h3>

  <div class="table-actions" *ngIf="showAddRowButton && !showInlineAddRowButton">
    <button type="button" class="add-row-button" (click)="onAddRowClick($event)">
      {{ addRowButtonLabel }}
    </button>
  </div>

  <div class="table-shell">
    <div
      class="table-scroll-container"
      [style.maxHeight.px]="tableViewportMaxHeightPx"
      [style.height.px]="tableViewportHeightPx">
      <table mat-table [dataSource]="dataSource" class="discount-table"
        [class.terms-conditions-table]="data?.widgetId === 'termsAndConditionsTable'"
        [class.quote-level-discount-table]="data?.widgetId === 'quoteLevelDiscountTable'">
        <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column" [sticky]="isFrozenColumn(column)">
          <th class="header-cell"
            [ngClass]="getHeaderCellClasses(column)"
            [attr.data-column-key]="column"
            mat-header-cell *matHeaderCellDef>
            <div class="header-content">
              <span class="header-text">{{ formatHeaderLabel(columnLabels[column]) }}</span>
              <button
                *ngIf="canToggleColumnEdit(column)"
                type="button"
                class="header-edit-toggle"
                [class.active]="isColumnEditEnabled(column)"
                (click)="toggleColumnEdit(column, $event)"
                [attr.aria-label]="isColumnEditEnabled(column) ? 'Disable edit mode' : 'Enable edit mode'">
                <mat-icon>{{ isColumnEditEnabled(column) ? 'check' : 'edit' }}</mat-icon>
              </button>
            </div>
          </th>

          <td class="body-cell" [ngClass]="getBodyCellClasses(column, row)" [attr.data-column-key]="column" mat-cell *matCellDef="let row">
            <ng-container *ngIf="isDropdownColumn(column, row) && isColumnEditable(column, row); else nonDropdownCell">
              <mat-form-field appearance="outline" class="dropdown-field"
                [class.compact-dropdown]="isCompactColumn(column)"
                [class.numeric-dropdown]="isNumericColumn(column, row)">
                <mat-select [multiple]="isMultiSelect(column, row)" [ngModel]="row[column]"
                  (ngModelChange)="onDropdownChange(row, column, $event)"
                  [placeholder]="getCellConfig(row, column)?.placeholder || dropdownColumnConfig[column]?.placeholder || 'Select'">
                  <mat-option *ngFor="let option of getDropdownOptions(row, column)" [value]="option">
                    {{ option }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>

            <ng-template #nonDropdownCell>
              <ng-container *ngIf="isInputColumn(column, row) && isColumnEditable(column, row); else textCell">
                <mat-form-field appearance="outline" class="input-field"
                  [class.compact-input]="isCompactColumn(column)"
                  [class.numeric-input]="isNumericColumn(column, row)"
                  [class.manual-row-input]="isManualAddedRow(row)">
                  <input matInput [type]="getInputType(column, row)"
                    [attr.inputmode]="isNumericColumn(column, row) ? 'decimal' : null"
                    dir="ltr"
                    [value]="getInputDisplayValue(column, row[column], row)"
                    (input)="onTextInputChange(row, column, $any($event.target).value, $event)"
                    [placeholder]="getInputPlaceholder(column, row)" />
                </mat-form-field>
              </ng-container>
              <ng-template #textCell>
                {{ getCellDisplayValue(column, row[column], row) }}
              </ng-template>
            </ng-template>
          </td>
        </ng-container>

        <ng-container [matColumnDef]="rowRemoveActionColumn">
          <th class="header-cell row-action-column" mat-header-cell *matHeaderCellDef>
            <label class="select-all-checkbox">
              <input
                type="checkbox"
                [checked]="areAllRowsChecked()"
                [indeterminate]="isSomeRowChecked()"
                (change)="onSelectAllRowsChange($event)" />
              <span>Select All</span>
            </label>
          </th>
          <td class="body-cell row-action-column" mat-cell *matCellDef="let row">
            <input
              type="checkbox"
              class="row-select-checkbox"
              [checked]="isRowChecked(row)"
              (change)="onRowCheckboxChange(row, $event)" />
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="tableRenderColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: tableRenderColumns;"></tr>
      </table>
    </div>
  </div>
  <div class="table-footer-line" *ngIf="shouldShowFooterLine">
    <div class="table-footer-separator"></div>
    <h4 class="table-footer-text">
      {{ footerLineText }}
    </h4>
  </div>

  <div class="table-footer-actions" *ngIf="showFooterButton">
    <button
      *ngIf="showRowDeleteButton"
      type="button"
      class="footer-action-button footer-delete-button"
      [disabled]="isFooterDeleteDisabled()"
      (click)="onFooterDeleteClick($event)">
      {{ getFooterDeleteButtonLabel() }}
    </button>
    <button
      *ngIf="showInlineAddRowButton"
      type="button"
      class="footer-action-button footer-secondary-button"
      (click)="onAddRowClick($event)">
      {{ addRowButtonLabel }}
    </button>
    <button
      *ngFor="let config of footerButtonConfigs"
      type="button"
      class="footer-action-button"
      [disabled]="isFooterButtonDisabled(config) || isFooterButtonLoading(config)"
      (click)="onFooterButtonClick(config, $event)">
      {{ getFooterButtonRenderLabel(config) }}
    </button>
  </div>
</div>
